/**
 * Module-level store for enabled Unleash feature flags.
 * This is NOT a React store — it's a plain JS module so it can be read from
 * non-React code like restClient.ts at request time.
 *
 * Updated by the React layer (via useSourceFeatureFlags hook in AppRouter)
 * whenever Unleash flags change.
 *
 * Values are raw Unleash flag names (e.g., "Kilde-Eurlex", "PII-Redaction").
 */

let enabledFeatures: string[] = [];

export const setEnabledFeatures = (features: string[]) => {
  enabledFeatures = features;
};

export const getEnabledFeatures = (): string[] => enabledFeatures;
